import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { schemaAcc2Acc } from 'app/pages/TransferPage/schema';
import { useFilterTemplate, useGetTemplates } from 'app/utils/services/templateService';
import { useNavigate } from 'react-router-dom';
import { getTheme } from 'app/components/ThemeProvider/theme';
import { useMediaQuery } from '@mui/material';
import { debounce } from 'lodash';
import logger from 'app/utils/logger';
import CoinsSwapIcon from 'app/components/Icons/CoinsSwapIcon';
import BankIcon from 'app/components/Icons/BankIcon';
import ManatIcon from 'app/components/Icons/ManatIcon';
import GlobusIcon from 'app/components/Icons/GlobusIcon';
import SwitchIcon from 'app/components/Icons/SwitchIcon';
import CoinsStackedIconSelect from 'app/components/Icons/CoinsStackedIconSelect';
import WalletIconSelect from 'app/components/Icons/WalletIconSelect';

// const filterBtns = [
//   { id: 1, title: 'Hamısı' },
//   { id: 2, title: 'Şablonlar' },
//   { id: 3, title: 'Mütəmadi ödənişlər' },
// ];

const useTransferPage = () => {
  const [btnId, setBtnId] = useState(1);
  const [searchInputValue, setSearchInputValue] = useState('');
  const [selectedType, setSelectedType] = useState<any>([]);

  const [page, setPage] = useState(1);

  const navigate = useNavigate();

  const theme = getTheme('light');
  const mediumScreens = useMediaQuery(theme.breakpoints.down('md'));

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const DEBOUNCE_TIME_MS = 300;

  const { filterTemplateMutation, isLoadingFilterTemplate, dataFilterTemplate } = useFilterTemplate();

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  const { isLoadingGetTemplates, refetchGetTemplate, dataGetTemplates } = useGetTemplates();

  // const handleSearchInputValue = (event: any) => {
  //   setSearchInputValue(event.target.value);
  // };

  const handleSearchInputValue = useMemo(
    () =>
      debounce((e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchInputValue(e.target.value);
        filterTemplateMutation({
          search: e.target.value,
          filter: 'templates',
          offset: 0,
          limit: '30',
          trn_type: selectedType,
        });
      }, DEBOUNCE_TIME_MS),
    []
  );

  useEffect(() => {
    return () => {
      handleSearchInputValue.cancel();
    };
  }, [handleSearchInputValue]);

  useEffect(() => {
    refetchGetTemplate();
  }, []);

  const options = [
    {
      value: 'payment_acc2acc',
      label: 'Öz hesablarım arasında',

      templateType: 'payment_acc2acc',
    },
    { value: 'payment_interbank', label: 'Bankdaxili', templateType: 'payment_interbank' },
    { value: 'payment_local_transfer', label: 'Ölkədaxili', templateType: 'payment_local_transfer' },
    { value: 'payment_foreign_transfer', label: 'Xarici valyutada', templateType: 'payment_foreign_transfer' },
    {
      value: 'payment_conversion',
      label: 'Konvertasiya',

      templateType: 'payment_conversion',
    },
    { value: 'payment_edv', label: 'Ədv ödənişi', templateType: 'payment_edv' },
    { value: 'payment_budget', label: 'Büdcə ödənişi', templateType: 'payment_budget' },
  ];

  const valueRef = useRef(selectedType);
  valueRef.current = selectedType;

  const selectAllOption = {
    value: 'all',
    label: 'Hamısı',
  };

  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);

    filterTemplateMutation({
      limit: '30',
      offset: String((value - 1) * 30),
      search: searchInputValue,
      filter: 'templates',
      trn_type: selectedType,
    });
  };

  const isOptionSelected = (option: any) => valueRef?.current.some(({ value }: any) => value === option.value);
  // || isSelectAllSelected();

  const getOptions = () => [selectAllOption, ...options];
  //
  const getValue = () =>
    // isSelectAllSelected() ? [selectAllOption] :
    selectedType;

  const onChange = (newValue: any, actionMeta: any) => {
    const { action, option, removedValue } = actionMeta;

    if (action === 'select-option' && option.value === selectAllOption.value) {
      logger.log('in first if ');
      setSelectedType(options);
    } else if (
      (action === 'deselect-option' && option.value === selectAllOption.value) ||
      (action === 'remove-value' && removedValue.value === selectAllOption.value)
    ) {
      setSelectedType([]);
    } else if (actionMeta.action === 'deselect-option') {
      // setSelectValue(paymentStatus.filter(({ value }: any) => value !== option.value));
      setSelectedType(newValue || []);
    } else {
      setSelectedType(newValue || []);
      // setSelectedValueStatus(newValue.map((item: any) => item.value));
    }

    filterTemplateMutation({
      limit: '30',
      offset: '0',
      search: searchInputValue,
      filter: 'templates',
      trn_type: newValue.map((item: any) => item.value),
    });
  };

  // const handleChangeSelectedType = (newValue: any) => {
  //   setSelectedType(newValue);
  //
  //   filterTemplateMutation({
  //     search: searchInputValue,
  //     filter: 'templates',
  //     offset: 0,
  //     limit: '30',
  //     trn_type: newValue.templateType,
  //   });
  // };

  const {
    handleSubmit,
    control,
    register,
    getValues,
    setValue,
    formState: { errors },
    clearErrors,
    trigger,
  } = useForm();

  return {
    // filterBtns,
    control,
    register,
    btnId,
    setBtnId,
    searchInputValue,
    setSearchInputValue,
    handleSearchInputValue,
    dataGetTemplates,
    isLoadingGetTemplates,
    navigate,
    mediumScreens,
    open,
    anchorRef,
    handleClose,
    handleToggle,
    handleListKeyDown,
    onChange,
    selectedType,
    dataFilterTemplate,
    isLoadingFilterTemplate,
    optionsFilter: options,
    getValue,
    isOptionSelected,
    page,
    handleChangePage,
  };
};

export default useTransferPage;
